import { createSelector } from 'reselect'

export const getUsers = (state) => state.user.users
export const getSelected = state => state.user.selectUser
export const loadAvatar = state => state.user.loadAvatar
export const uploadImage = state => state.user.uploadImage
export const getUserSelected = createSelector([getUsers, getSelected] , (users, selected) => {
  return users.find(u => u.userId === selected) || null
})
